import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Seo } from "@/components/Seo";
import { Breadcrumb, breadcrumbJsonLd } from "@/components/Breadcrumb";
import { ImageSlot } from "@/components/ImageSlot";
import { Reveal } from "@/components/Reveal";
import { CtaBand } from "@/components/home/CtaBand";

const BREADCRUMB = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
];

const ANCHORS = {
  extensions: "Our house extensions service",
  plastering: "Our plastering service",
  "loft-conversions": "Our loft conversions service",
  kitchens: "Our kitchen fitting service",
  bathrooms: "Our bathroom installation service",
  refurbishments: "Our house refurbishment service",
};

export default function ServicesHub() {
  return (
    <div data-testid="services-hub-page">
      <Seo
        title="Building Services Molesey & Kingston | DMS Home Improvements"
        description="Extensions, loft conversions, plastering, kitchens, bathrooms and refurbishments in Molesey, Kingston and Surrey. Family-run builders, free site visit and fixed written quote."
        jsonLd={breadcrumbJsonLd(BREADCRUMB)}
      />
      <section className="section bg-white">
        <div className="container-site">
          <Breadcrumb items={BREADCRUMB} />
          <Reveal className="mt-8 max-w-[720px]">
            <h1 data-testid="page-heading">Our Services in Molesey &amp; Kingston</h1>
            <p className="mt-6 text-lg text-body">
              From a patch repair to a full extension, we handle the lot. Every job starts with a free site visit and a fixed written quote, and every job is finished with the same care.
            </p>
          </Reveal>
          <ul className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3 xl:gap-8">
            {SERVICES.map((s, i) => (
              <Reveal as="li" key={s.id} delay={i * 60}>
                <Link
                  to={s.to}
                  data-testid={`hub-service-card-${s.id}`}
                  className="card group flex h-full flex-col overflow-hidden transition-[border-color] duration-200 hover:border-brand"
                >
                  <ImageSlot label={s.slot.id} note={s.slot.note} ratio="4:3" alt={s.alt} imgClassName="transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
                  <div className="flex flex-1 flex-col p-6">
                    <h2 className="text-2xl">{s.title}</h2>
                    <p className="mt-2 text-base text-body">{s.line}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-[15px] font-semibold text-brand">
                      {ANCHORS[s.id]}
                      <ArrowRight size={18} aria-hidden="true" className="transition-transform duration-200 ease-out group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
